var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection } from './utils';
const initialState = {
    data: [],
    loading: false,
    count: 0,
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const updateAssetLinks = createAsyncThunk('reduxAssetLinks/update', (assetLinks_1, _a) => __awaiter(void 0, [assetLinks_1, _a], void 0, function* (assetLinks, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.assetLinks.collection.create(assetLinks);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const deleteAssetLinks = createAsyncThunk('reduxAssetLinks/delete', (assetLinksIds_1, _a) => __awaiter(void 0, [assetLinksIds_1, _a], void 0, function* (assetLinksIds, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.assetLinks.collection.delete(assetLinksIds);
        return fulfillWithValue(assetLinksIds);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const updateAndDeleteAssetLinks = createAsyncThunk('reduxAssetLinks/updateAndDelete', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ assetLinksToUpdate, assetLinksIdsToDelete, }, { fulfillWithValue, rejectWithValue }) {
    try {
        const toUpdate = assetLinksToUpdate.length && api.assetLinks.collection.create(assetLinksToUpdate);
        const toDelete = assetLinksIdsToDelete.length && api.assetLinks.collection.delete(assetLinksIdsToDelete);
        const [response] = yield Promise.all([toUpdate, toDelete]);
        return fulfillWithValue({ response, assetLinksIdsToDelete });
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const updateAndDeleteAssetLinksAction = updateAndDeleteAssetLinks.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxAssetLinks',
    initialState,
    reducers: {
        createAssetLinksFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (link) => link.id);
            state.data = newData;
        },
        deleteAssetLinksFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = [...state.data].filter((link) => link.id !== updatedPayload.id);
            state.data = newData;
        },
        setAllRelAssetLinks: (state, { payload }) => {
            state.data = payload;
        },
    },
    extraReducers: (builder) => {
        // DELETE ASSET LINK RELATION
        builder.addCase(deleteAssetLinks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteAssetLinks.fulfilled, (state, { payload }) => {
            const idsArr = payload.map((el) => el.id);
            const newData = deleteDataFomCollection(state.data, idsArr);
            state.data = newData;
        });
        builder.addCase(deleteAssetLinks.rejected, (state) => {
            state.loading = false;
        });
        // UPDATE ASSET LINK RELATION
        builder.addCase(updateAssetLinks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateAssetLinks.fulfilled, (state, { payload }) => {
            state.data = [...state.data, ...payload];
        });
        builder.addCase(updateAssetLinks.rejected, (state) => {
            state.loading = false;
        });
        // CREATE AND DELETE ASSET LINKS
        builder.addCase(updateAndDeleteAssetLinks.pending, () => { });
        builder.addCase(updateAndDeleteAssetLinksAction, (state, { payload }) => {
            const { response, assetLinksIdsToDelete } = payload;
            const idsArr = assetLinksIdsToDelete.map((el) => el.id);
            if (response) {
                const t = [...state.data, ...response];
                const cleanedData = removeDuplicates(t, (flag) => flag.id);
                const newData = deleteDataFomCollection(cleanedData, idsArr);
                state.data = newData;
            }
            else {
                const newData = deleteDataFomCollection(state.data, idsArr);
                state.data = newData;
            }
        });
        builder.addCase(updateAndDeleteAssetLinks.rejected, (state, { payload }) => {
            state.error = payload;
        });
    },
});
export const { setAllRelAssetLinks, createAssetLinksFromWS, deleteAssetLinksFromWS } = actions;
export default reducer;
